import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import 'tslib';
import '@popperjs/core';
import { useTitle } from '../../utils/useTitle/useTitle.esm.js';
import { LoadingPage } from './LoadingPage.esm.js';

/**
 * Helps layout controls of a page.
 * Will handle spacing of common page elements.
 */
function PageLayout(_a) {
    var children = _a.children, documentTitle = _a.documentTitle, header = _a.header, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, tabList = _a.tabList, filterBar = _a.filterBar, _c = _a.noPadding, noPadding = _c === void 0 ? false : _c, _d = _a.overflow, overflow = _d === void 0 ? false : _d;
    useTitle(documentTitle);
    var headerClasses = classNames("tw-p-4 tw-bg-white dark:tw-bg-gray-1000", !tabList && "tw-border-b tw-border-gray-300 dark:tw-border-gray-700");
    var mainContentClasses = classNames("tw-flex tw-flex-col tw-flex-grow dark:tw-bg-gray-1000", !noPadding && "tw-p-4", overflow && "tw-overflow-auto");
    return (React.createElement("div", { className: "tw-flex tw-flex-col tw-w-full" },
        React.createElement("div", { className: headerClasses }, header),
        tabList && (React.createElement("div", { className: "tw-bg-white dark:tw-bg-gray-1000" }, tabList)),
        filterBar && (React.createElement("div", { className: "tw-font-lato tw-border-solid tw-px-4 tw-py-2 tw-bg-gray-100 tw-border-b tw-border-gray-300 dark:tw-bg-gray-1000 dark:tw-border-gray-700" }, filterBar)),
        React.createElement("div", { className: mainContentClasses }, isLoading ? React.createElement(LoadingPage, null) : children)));
}

export { PageLayout };
//# sourceMappingURL=PageLayout.esm.js.map
